export class FiledValidationInfo {
  public status: boolean;
  public description: string;

  constructor(status: boolean = true, description: string = '') {
    this.status = status;
    this.description = description;
  }
}